import type { Item } from "../types/common";
import { DEFAULT_ALL_ITEM } from "../types/common";

export enum StringBuilderFunctions {
    NumberFormat = "NumberFormat",
    Capitalize = "Capitalize",
}

export const StringBuilderFunctionsImplementations: {
    [key in StringBuilderFunctions]: (value: string, args: any) => string;
} = {
    [StringBuilderFunctions.NumberFormat]: (value, args) => {
        return Intl.NumberFormat(navigator.language, args).format(
            Number(value),
        );
    },
    [StringBuilderFunctions.Capitalize]: (value) => {
        return value.charAt(0).toUpperCase() + value.slice(1);
    },
};

export enum StringBuilderRegExpGroups {
    Match = 0,
    Function = 2,
    FunctionArgument = 4,
    Value = 6,
}

export const StringBuilderRegExp =
    /(\((\w+)(\(([\w\d\s"{}:,]*)\))?\))?(\{(\w+)\})/g;

export const stringBuilderWithData = (
    text: string,
    data: Record<string, string>,
): string => {
    const groups = [...text.matchAll(StringBuilderRegExp)];
    groups.forEach((group) => {
        // get value
        let value = data[group[StringBuilderRegExpGroups.Value]];
        const processingFunctionName =
            group[StringBuilderRegExpGroups.Function];
        const processingFunction: (value: string, args: any) => string =
            StringBuilderFunctionsImplementations[processingFunctionName];
        const processingFunctionArg =
            group[StringBuilderRegExpGroups.FunctionArgument];

        if (!value) {
            value = `[KEY-NOT-FOUND:${group[StringBuilderRegExpGroups.Value]}]`;
        } else if (
            group[StringBuilderRegExpGroups.Function] &&
            !processingFunction
        ) {
            value = `[FUNCTION-NOT-FOUND:${processingFunctionName}]`;
        } else if (processingFunction) {
            if (processingFunctionArg) {
                try {
                    const args = JSON.parse(processingFunctionArg);
                    value = processingFunction(value, args);
                } catch (e: unknown) {
                    if (e instanceof Error) {
                        if (e.name === "SyntaxError") {
                            value = `[INVALID-ARGUMENT-FORMAT:${processingFunctionName}]`;
                        } else if (e.message) {
                            value = `[${e.message}:${processingFunctionName}]`;
                        }
                    }
                }
            }
        }
        text = text.replace(group[StringBuilderRegExpGroups.Match], value);
    });
    return text;
};

export const equalsDefaultValue = (item: Item): boolean => {
    return (
        item.label === DEFAULT_ALL_ITEM.label &&
        item.value === DEFAULT_ALL_ITEM.value
    );
};
